// extracted by mini-css-extract-plugin
export default {"container":"qeLzvsDkOR0CqQHAvyv7","icon":"__PjoMrzLAi_cB3UQURQ","marginRightIcon":"gqSh3L1waYQ6KwKAVghI"};